export const ApartmentGroupDebtTypes = {
  SHOW_APARTMENT_GROUP_DEBT: 'SHOW_APARTMENT_GROUP_DEBT',
  ADD_GROUP_DEBT: 'ADD_GROUP_DEBT',
  SHOW_DEBT_GROUPP: 'SHOW_DEBT_GROUPP',
}
